import { ErrorCodes } from '~/enums/Errors';
import CancellationReasons from '~/enums/CancellationReasons';

export const errorsMetaData: {
  [key in ErrorCodes]?: {
    textsKey?: string;
    isDeclineStatus?: boolean;
    cancelApplication?: boolean;
    cancellationReason?: CancellationReasons;
    showRefreshButton?: boolean;
  };
} = {
  [ErrorCodes.ExceededVerificationAttempts]: {
    textsKey: 'exceeded_verification_attempts',
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.AgeRestriction]: {
    textsKey: 'age_restriction',
    cancelApplication: true,
  },
  [ErrorCodes.AgeRestriction19]: {
    textsKey: 'age_restriction_19',
    cancelApplication: true,
  },
  [ErrorCodes.LeftMaxAmountsBeforeTaxErrorCode]: {
    textsKey: 'left_max_amounts_before_tax_error_code',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
    // TODO ask BE where it happens
    // TODO ask Maya if it's relevant
  },
  [ErrorCodes.OnlineCancellationErrorCode]: {
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.OfacPendingError]: {
    textsKey: 'ofac_pending_error',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.OfacFinalError]: {
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.SsnRequired]: {
    textsKey: 'ssn_required',
  },
  [ErrorCodes.DuplicateSSN]: {
    textsKey: 'duplicate_ssn',
    cancelApplication: true,
    // TODO ask Maya what to do with this
  },
  [ErrorCodes.SsnVerificationFailedTooManyTimes]: {
    textsKey: 'ssn_verification_failed_too_many_times',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.ExtraVerificationFailed]: {
    isDeclineStatus: true,
    cancelApplication: true,
  },
  [ErrorCodes.ConsumerAlert]: {
    // TODO ask Maya what to do with this
    textsKey: 'consumer_alert',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.PurchaseFinanceAmount]: {
    textsKey: 'purchase_finance_amount',
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.NumberOfAllowedActiveLoansExceeded]: {
    textsKey: 'number_of_allowed_active_loans_exceeded',
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.IllegalArgument]: { textsKey: 'illegal_argument' },
  [ErrorCodes.RejectionErrorCode140]: { textsKey: 'rejection_error_code_140' },
  [ErrorCodes.RejectionErrorCode6]: {
    textsKey: 'rejection_error_code_6',
  },
  [ErrorCodes.RejectionErrorCode2]: { textsKey: 'rejection_error_code_2' },
  [ErrorCodes.RejectionErrorCode145]: { textsKey: 'rejection_error_code_145' },
  [ErrorCodes.RejectionErrorCode160]: { textsKey: 'rejection_error_code_160' },
  [ErrorCodes.RejectionErrorCode165]: { textsKey: 'rejection_error_code_165' },
  [ErrorCodes.InvalidRoutingNumber]: { textsKey: 'invalid_routing_number' },
  [ErrorCodes.SsnNotValid]: { textsKey: 'ssn_not_valid' },
  [ErrorCodes.CancellationErrorCode6]: {
    textsKey: 'cancellation_error_code_6',
  },
  [ErrorCodes.CancellationErrorCode10]: {
    isDeclineStatus: true,
    cancelApplication: true,
  },
  [ErrorCodes.CancellationErrorCode22]: {
    textsKey: 'cancellation_error_code_22',
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode90]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode91]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode95]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode96]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode97]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode98]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode99]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode100]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode101]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode102]: {
    textsKey: 'cancellation_error_code_102',
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode104]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode107]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode108]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode113]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode114]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode115]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode116]: {
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode118]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode120]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode125]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode130]: {
    textsKey: 'cancellation_error_code_130',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode132]: {
    textsKey: 'cancellation_error_code_132',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode190]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode191]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode192]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode210]: {
    textsKey: 'cancellation_error_code_210',
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode221]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode223]: {
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode230]: {
    cancelApplication: true,
    isDeclineStatus: true,
    showRefreshButton: true,
  },
  [ErrorCodes.CancellationErrorCode300]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.ExtraVerificationRequired]: {
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.ErrorEmail]: {
    textsKey: 'error_email',
  },
  [ErrorCodes.DuplicateEmailError]: {
    textsKey: 'error_email',
  },
  [ErrorCodes.ChargeFailed]: {
    textsKey: 'charge_failed',
    isDeclineStatus: true,
    cancelApplication: true,
    showRefreshButton: true,
  },
  [ErrorCodes.FallbackError]: {
    textsKey: 'fallback_error',
    cancellationReason: CancellationReasons.TechnicalIssue,
  },
  [ErrorCodes.PurchaseAmountLimit]: {
    textsKey: 'purchase_amount_limit',
  },
  [ErrorCodes.AccountAlreadyExists]: {
    cancelApplication: true,
  },
  [ErrorCodes.LinkCreationError]: {
    textsKey: 'link_creation_error',
  },
  [ErrorCodes.ResendVerificationEmailNotAllowed]: {
    textsKey: 'resend_verification_email_not_allowed',
    showRefreshButton: true,
  },
  [ErrorCodes.ResendEmailTechnicalError]: {
    textsKey: 'resend_email_technical_error',
  },
};
